import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SolutionResponse } from '../models/solutions.types';
import { ApiConfigService } from '../../../core/services/api-config.service';
import { Period } from '../../../core/constants/periods';

export abstract class SolutionsDataSource {
  abstract getSolutions(projectId: string, period: Period): Observable<SolutionResponse[]>;
}

export class ApiSolutionsDataSource implements SolutionsDataSource {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfigService);

  getSolutions(projectId: string, period: Period): Observable<SolutionResponse[]> {
    return this.http.get<SolutionResponse[]>(this.apiConfig.endpoint(`project/${projectId}/solutions`), {
      params: {
        period: period,
      },
    });
  }
}
